const l=l=>null!=(null==l?void 0:l.isLoyalty)?l.isLoyalty?1:0:null;export{l as buildDimension71};
